import React from "react";
import FaqAccordion from "../faq/FaqAccordion";

import faq01 from "../../../../public/assets/faqs/de/faq01.json";
import faq02 from "../../../../public/assets/faqs/de/faq02.json";
import faq03 from "../../../../public/assets/faqs/de/faq03.json";
import faq04 from "../../../../public/assets/faqs/de/faq04.json";
import faq05 from "../../../../public/assets/faqs/de/faq05.json";
import faq06 from "../../../../public/assets/faqs/de/faq06.json";
import faq07 from "../../../../public/assets/faqs/de/faq07.json";

const IndexAccordionDe: React.FC<{}> = () => {
  return (
    <FaqAccordion faqs={[faq01, faq02, faq03, faq04, faq05, faq06, faq07]} />
  );
};

export default IndexAccordionDe;
